import type { AppConfig, DataProvider } from "../types/index";
import { MockProvider } from "./providers/mockProvider";
import { GoogleSheetsProvider } from "./providers/googleSheetsProvider";

/**
 * Creates a provider with a shared contract so UI code is backend-agnostic.
 */
export function createProvider(config: AppConfig): DataProvider {
  if (config.provider === "googleSheets") {
    return new GoogleSheetsProvider(config.googleSheets);
  }

  return new MockProvider();
}
